import jwtDecode from 'jwt-decode'

const decodeJWT = token => {
	try {
		return jwtDecode(token)
	} catch (error) {
		return ''
	}
}

export default decodeJWT
